import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchCourses } from "../redux/slices/courseSlice"
import Sidebar from "../components/Sidebar"
import DashboardHeader from "../components/DashboardHeader"
import CourseCard from "../components/CourseCard"
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const EnrolledCoursesPage = () => {
  const dispatch = useDispatch()
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [activeTab, setActiveTab] = useState("enrolled")

  const { enrolled, active, completed, loading, error } = useSelector((state) => state.courses)
  const [profilePhoto, setProfilePhoto] = useState(null);
  const accessToken = useSelector((state) => state.auth.access)
  const user = useSelector((state) => state.auth.user)

  // Fetch profile photo separately
    useEffect(() => {
      const fetchUserProfile = async () => {
        try {
          const token = localStorage.getItem("access");
          const res = await axios.get(`${BASE_URL}/users/profile/`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const p = res.data.profile_photo;
          if (p) {
            setProfilePhoto(
              p.startsWith("http") ? p : `${BASE_URL}${p}`
            );
          } else {
            setProfilePhoto(null);
          }
        } catch (e) {
          setProfilePhoto(null);
        }
      };
      fetchUserProfile();
    }, []);

  const tabs = [
    { key: "enrolled", label: "Enrolled Courses", count: enrolled.length },
    { key: "active", label: "Active Courses", count: active.length },
    { key: "completed", label: "Completed Courses", count: completed.length },
  ]

  const getCurrentCourses = () => {
    if (activeTab === "enrolled") return enrolled
    if (activeTab === "active") return active
    if (activeTab === "completed") return completed
    return []
  }

  useEffect(() => {
    if (accessToken) {
      dispatch(fetchCourses(accessToken))
    }
  }, [accessToken, dispatch])

  return (
    <div className="dashboard-container">
      <div className="d-flex">
        <Sidebar collapsed={sidebarCollapsed} toggleSidebar={() => setSidebarCollapsed((prev) => !prev)}/>
        <div className="main-content flex-grow-1">
        <DashboardHeader user={user} profilePhoto={profilePhoto} onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} />
          <div className="dashboard-content p-4">
            <h2 className="dashboard-title mb-4">Enrolled Courses</h2>

            {/* Tabs */}
            <div className="course-tabs mb-4">
              <div className="tab-navigation-courses">
                {tabs.map((tab) => (
                  <button
                    key={tab.key}
                    className={`course-tab ${activeTab === tab.key ? "active" : ""}`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    {tab.label} {tab.count > 0 && `(${tab.count})`}
                  </button>
                ))}
              </div>
            </div>

            {/* Content */}
            <div className="courses-content">
              {loading ? (
                <p>Loading...</p>
              ) : error ? (
                <p className="text-danger">Error: {error}</p>
              ) : getCurrentCourses().length > 0 ? (
                <div className="row">
                  {getCurrentCourses().map((item) => {
                    const course = item.course || item // support both structures
                    return (
                      <div key={item.id} className="col-lg-4 col-md-6 mb-4">
                        <CourseCard
                          course={{
                            id: course.id,
                            title: course.title,
                            image: course.image || "/placeholder.svg",
                            rating: course.average_rating || 0,
                            reviewCount: course.review_count || 0,
                            completedLessons: course.progress.completed,
                            totalLessons: course.progress.total,
                            progressPercentage: course.progress.percentage,
                          }}
                          showContinueButton={true}
                        />
                      </div>
                    )
                  })}
                </div>
              ) : (
                <div className="text-center py-5 text-muted">No courses found</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EnrolledCoursesPage
